import { Button, Modal } from 'react-bootstrap';

import CustomModal from '@/resources/components/global/CustomModal';
import { useDevice } from '@/resources/hooks/useDevice';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { changeItem } from '@/routes/order';
import { IProduct } from '@/store/ducks/products/types';

export function ComboRemoveItemModal({
  show,
  onClose,
  product,
}: {
  show: boolean;
  onClose: () => void;
  product: IProduct | undefined;
}) {
  const { order } = useWebContext();
  const { device } = useDevice();

  const unsubmitComboPromotion = () => {
    changeItem(order?.id as number, {
      product_id: product?.product_id as number,
      quantity: product?.quantity ? Number(product?.quantity) - 1 : 0,
      ean: product?.ean as string,
      uid: product?.uid as string,
      options: [],
    }).finally(() => {
      onClose();
    });
  };

  return (
    <CustomModal show={show} onHide={onClose} size="md" centered>
      <Modal.Body className="p-1 pt-3">
        <p className="text-center d-flex flex-column" style={{ fontSize: '1.25rem' }}>
          <strong>Deseja mudar a quantidade do produto?</strong>

          <span>
            Ao editar a quantidade desse produto você{' '}
            <span style={{ fontWeight: 'bold' }}>perderá o desconto do combo</span>
          </span>
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center flex-md-row flex-column-reverse w-100">
        <Button
          variant="primary"
          onClick={() => {
            onClose();
          }}
          style={{ fontSize: '1rem', width: device === 'desktop' ? '16.469rem' : '22.375rem' }}
        >
          Manter descontos do combo
        </Button>
        <Button
          variant="outline-secondary"
          onClick={() => unsubmitComboPromotion()}
          style={{ fontSize: '1rem', width: device === 'desktop' ? '16.469rem' : '22.375rem' }}
        >
          Sim, quero mudar
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
